import React from 'react';

export const ReactionSmiley: React.FC = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='none' viewBox='0 0 16 16'>
    <path
      fill='var(--text-high-emphasis)'
      fillRule='evenodd'
      d='M3.475 3.475a6.4 6.4 0 119.05 9.05 6.4 6.4 0 01-9.05-9.05zM8 0a8 8 0 100 16A8 8 0 008 0zM6.849 6.849A1.2 1.2 0 105.15 5.152 1.2 1.2 0 006.85 6.849zm4 0A1.2 1.2 0 109.15 5.15a1.2 1.2 0 001.698 1.698zm-6.222 1.97a.8.8 0 00-.482 1.24c.541.774 1.578 1.736 2.962 2.024 1.46.303 3.1-.184 4.687-1.948a.8.8 0 10-1.188-1.07C9.313 10.5 8.22 10.68 7.433 10.517c-.863-.18-1.586-.817-1.978-1.375a.8.8 0 00-.828-.324z'
      clipRule='evenodd'
    ></path>
  </svg>
);
